module.exports = __webpack_public_path__ + "img/sodexo.20507295.svg";